import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CHECKS_PAGE_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { ChecksPageBlockScenarioContent } from '@front-platform/content-builder';

import {
  CHECKS_PAGE_BLOCK_LOADING_VM,
  ChecksPageBlockDataSource,
  ChecksPageBlockViewModel,
} from './checks-page-block-view-model';

export function toChecksPagePreviewViewModel(
  content: ChecksPageBlockScenarioContent,
): ChecksPageBlockViewModel {
  return {
    checks: content.checks as unknown as ChecksPageBlockViewModel['checks'],
    isChecksLoading: content.isChecksLoading,
  };
}

@Injectable()
export class ChecksPageBlockPreviewDataSource implements ChecksPageBlockDataSource {
  readonly vm$: Observable<ChecksPageBlockViewModel> = previewScenarioForBloc$(
    CHECKS_PAGE_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return CHECKS_PAGE_BLOCK_LOADING_VM;
      }

      const content = previewScenarioData<ChecksPageBlockScenarioContent>(
        scenario,
        CHECKS_PAGE_BLOCK_COMPONENT,
      );
      return content ? toChecksPagePreviewViewModel(content) : CHECKS_PAGE_BLOCK_LOADING_VM;
    }),
  );
}
